import { useMemo } from '@wordpress/element';
import * as styles from '../styles';
import { useContextSystem } from '../../context';
import { useCx } from '../../utils';
export function useBorderBoxControlVisualizer(props) {
  const {
    className,
    value,
    ...otherProps
  } = useContextSystem(props, 'BorderBoxControlVisualizer');

  // Generate class names.
  const cx = useCx();
  const classes = useMemo(() => {
    return cx(styles.borderBoxControlVisualizer(value), className);
  }, [cx, className, value]);
  return {
    ...otherProps,
    className: classes,
    value
  };
}